<div class="d-flex flex-column justify-content-start align-items-center h-100 w-100">

    <app-header-section
        class="w-100"
        [title]="headerTitle"
        [buttonText]="headerButtonText"
        [buttonIcon]="headerButtonIcon"
        [buttonUrl]="headerButtonUrl">
    </app-header-section>

    <div class="card d-flex flex-column justify-content-start align-items-stretch h-100 w-75 my-3">

        <app-spinner
            [isLoading]="isLoadingData"
            [isFullScreen]="false">
        </app-spinner>

        <div *ngIf="showSuccessMessage && !isLoadingData"
            class="d-flex flex-column justify-content-start align-items-center h-100 w-100">

            <div class="col-12 col-lg-10 py-4">
                <div class="d-flex flex-column justify-content-start align-items-center text-center">
                    <fa-icon class="success-icon mb-3" [icon]="['fas', 'check-circle']" size="3x"></fa-icon>
                    <span class="fs-3 mb-3" [innerHTML]="successMessage"></span>
                    <div *ngIf="showApiErrorMessage" class="w-100">
                        <div class="alert alert-danger w-100">
                            <span class="fs-5 mb-3" [innerHTML]="apiErrorMessage"></span>
                        </div>
                    </div>
                    <button type="button" class="btn button-accent-color py-2 px-4" [routerLink]="successButtonUrl">
                        <span class="fs-5">{{successButtonText}}</span>
                    </button>
                </div>
            </div>

        </div>

        <div *ngIf="showErrorMessage"
            class="card d-flex flex-column justify-content-start align-items-center h-100 w-100">

            <div class="col-12 col-lg-6 py-4">
                <div class="d-flex flex-column justify-content-start align-items-center text-center">
                    <fa-icon class="error-icon mb-3" [icon]="['fas', 'exclamation-circle']" size="3x"></fa-icon>
                    <span class="fs-3 mb-3" [innerHTML]="errorMessage"></span>
                    <button type="button" class="btn button-primary-color py-2 px-4" [routerLink]="errorButtonUrl">
                        <span class="fs-5">{{errorButtonText}}</span>
                    </button>
                </div>
            </div>
        </div>

    </div>

</div>
